/**
 * Календарные даты для /api/staff/orders и /api/staff/calls (from/to).
 * На сервере: DATE(created_at AT TIME ZONE 'Asia/Tashkent') — здесь тот же день.
 * Раньше брали toISOString().slice(0,10) (UTC) → вечером в UZ «сегодня» в Ташкенте
 * не совпадал с UTC-датой, список заказов был пустой.
 */
export const STAFF_REPORT_TIMEZONE =
  process.env.REACT_APP_STAFF_REPORT_TZ || 'Asia/Tashkent';

export function ymdInStaffTz(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: STAFF_REPORT_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const y = parts.find((p) => p.type === 'year').value;
  const m = parts.find((p) => p.type === 'month').value;
  const d = parts.find((p) => p.type === 'day').value;
  return `${y}-${m}-${d}`;
}

/** Сдвиг календарного дня в TZ отчёта (UZ = фиксированный +05:00, без DST). */
export function addDaysYmd(ymd, deltaDays) {
  const anchor =
    STAFF_REPORT_TIMEZONE === 'Asia/Tashkent'
      ? `${ymd}T12:00:00+05:00`
      : `${ymd}T12:00:00Z`;
  const ms = new Date(anchor).getTime() + deltaDays * 86400000;
  return ymdInStaffTz(new Date(ms));
}
